<template>
    <b-card class="p-2 w-100 bg-white" body-class="d-flex flex-column p-0 my-0 border rounded shadow-sm ">
        <b-card-header header-tag="header" class="text-center font-weight-bold py-1 mx-0 w-100 bg-white">
			<!-- Sélection du mode de période -->
            <b-row align-v="center" class="px-0">
            <b-col cols="auto">
                <small class="pl-0 pr-3 font-weight-bold">{{$t('Period')}}</small>
            </b-col>
            <b-col class="px-2">
                <b-button-group class="d-flex btn-gray-light rounded-pill border border-gray">
                     <!-- Simple -> Simple -->
                    <b-button v-if="hasSimpleMode" @click="setPeriodMode(modeEnum.Simple)" :pressed="selectedMode === modeEnum.Simple" pill variant="outline-white" size="sm"
                                :class="[ 'periodMode border-0', {'text-black' : selectedMode != modeEnum.Simple}]">{{$t('Simple')}}</b-button>
                    <!-- Advanced -> Avancée -->
                    <b-button v-if="hasAdvancedMode" @click="setPeriodMode(modeEnum.Advanced)" :pressed="selectedMode === modeEnum.Advanced" pill variant="outline-white" size="sm"
                                :class="[ 'periodMode border-0', {'text-black' : selectedMode != modeEnum.Advanced}]" >{{$t('Advanced')}}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
    </b-card-header>
        <b-card-body class="py-0 bg-white">
            <b-row class="py-0">
                <!-- Mode Période Simple -->
                <b-card v-if="selectedMode == modeEnum.Simple" class="py-0 w-100 bg-white" body-class="d-flex flex-column no-border px-0 py-1 my-0">
                    <b-card-body v-if="hasPeriodWithPeriodicity" class="py-0">
                        <!-- Type de période simple AVEC periodicité -->
                        <b-row class="px-2">
                            <!-- Year -> Année -->
                            <b-button v-if="hasSimpleYearPeriodicity" @click="setSimplePeriod('Year')" :pressed="simplePeriodType == 'Year'" size="sm" class="mr-1 flex-grow-1" variant="outline-gray-dark text-black">{{$t('Year')}}</b-button>
                            <!-- Month -> Mois -->
                            <b-button v-if="hasSimpleMonthPeriodicity" @click="setSimplePeriod('Month')" :pressed="simplePeriodType == 'Month'" size="sm" class="mr-1 flex-grow-1" variant="outline-gray-dark text-black">{{$t('Month')}}</b-button>
                            <!-- Week -> Semaine -->
                            <b-button v-if="hasSimpleWeekPeriodicity" @click="setSimplePeriod('Week')" :pressed="simplePeriodType == 'Week'" size="sm" class="mr-1 flex-grow-1" variant="outline-gray-dark text-black">{{$t('Week')}}</b-button>
                            <!-- Day -> Jour -->
                            <b-button v-if="hasSimpleDayPeriodicity" @click="setSimplePeriod('Day')" :pressed="simplePeriodType == 'Day'" size="sm" class="flex-grow-1" variant="outline-gray-dark text-black">{{$t('Day')}}</b-button>
                        </b-row>
                        <hr class="my-2 text-muted" />
                        <!-- Liste des périodes simples -->
                        <b-row class="pr-1 pl-2">
                            <b-button v-for="simplePeriod in filteredSimplePeriods" :key="simplePeriod.Id" @click="speriods = simplePeriod.Extras['Period']; periodId = simplePeriod.Id" :pressed="periodId === simplePeriod.Id" pill size="sm" class="mr-1 mb-2 flex-grow-1" variant="border border-gray text-black bg-gray-light">
                                {{simplePeriod.Label}}
                            </b-button>
                        </b-row>
                    </b-card-body>
                    <b-card-body v-if="!hasPeriodWithPeriodicity" class="py-0">
                        <!-- Type de période simple SANS périodicité -->
                        <b-row class="px-2">
                            <b-button v-if="hasSimpleYearTimeUnit" @click="setSimpleTimeUnit('Year')" :pressed="simplePeriodTimeUnit == 'Year'" size="sm" class="mr-1 flex-grow-1" variant="outline-gray-dark text-black">{{$t('Year')}}</b-button>
                            <b-button v-if="hasSimpleMonthTimeUnit" @click="setSimpleTimeUnit('Month')" :pressed="simplePeriodTimeUnit == 'Month'" size="sm" class="mr-1 flex-grow-1" variant="outline-gray-dark text-black">{{$t('Month')}}</b-button>
                            <b-button v-if="hasSimpleWeekTimeUnit" @click="setSimpleTimeUnit('Week')" :pressed="simplePeriodTimeUnit == 'Week'" size="sm" class="mr-1 flex-grow-1" variant="outline-gray-dark text-black">{{$t('Week')}}</b-button>
                            <b-button v-if="hasSimpleDayTimeUnit" @click="setSimpleTimeUnit('Day')" :pressed="simplePeriodTimeUnit == 'Day'" size="sm" class="flex-grow-1" variant="outline-gray-dark text-black">{{$t('Day')}}</b-button>
                        </b-row>
                        <hr class="my-2 text-muted" />
                        <!-- Liste des périodes simples -->
                        <b-row class="pr-1 pl-2">
                            <b-button v-for="simplePeriod in filteredSimplePeriods" :key="simplePeriod.Id" @click="speriods = simplePeriod.Extras['Period']; periodId = simplePeriod.Id" :pressed="periodId === simplePeriod.Id" pill size="sm" class="mr-1 mb-2 flex-grow-1" variant="border border-gray text-black bg-gray-light">
                                {{simplePeriod.Label}}
                            </b-button>
                        </b-row>
                    </b-card-body>
                </b-card>
                <!-- Mode Période Avancé -->
                <b-card v-else class="py-0 w-100" body-class="d-flex bg-white flex-column no-border px-0 py-1 my-0">
                    <b-card-body class="py-0">
                        <!-- Liste des type de périodes avancés -->
                        <b-row v-if="hasAdvancedPeriodicity" class="px-2">
                            <b-button @click="setAdvancedPeriod(period.Id);" v-for="period in advancedPeriods" :key="period.Id" :pressed="selectedPeriod === period.Id" size="sm" class="mr-1 mb-1 flex-grow-1" variant="outline-gray-dark text-black">
                                {{ period.Label }}
                            </b-button>
                        </b-row>
                        <hr class="my-2 text-muted" />
                        <!-- Spécifications sur la période -->
                        <b-row align-h="center" class="px-2">
                            <b-tabs small pills fill no-fade v-model="tabIndex" class="w-100" content-class="pt-2 pr-1" :active-nav-item-class="'bg-' + Variant + '-light text-' + Variant + '-dark rounded-pill border border-gray p-1'" >
                                <!-- Periode Glissante -->
                                <!-- Sliding -> Glissant -->
                                <b-tab v-if="hasSlidingPeriod" @click="selectPeriodType('Sliding') /*selectedType = 'Sliding'*/" :title="$t('Sliding')" :title-link-class="{ 'text-muted bg-gray rounded-pill border border-gray p-1': selectedType != 'Sliding' }">
                                    <template>
                                        <b-row align-h="between" align-v="center">
                                            <b-col cols="2">
                                                <!-- Duration -> Durée -->
                                                <label :for="$id('slidingDuration')" class="m-0">{{$t('Duration')}}</label>
                                            </b-col>
                                            <b-col cols="10">
                                                <b-input-group >
                                                    <b-form-input :id="$id('slidingDuration')" number min="1" max="100" size="sm" no-wheel v-model="duration" :state="durationValid"  :formatter="onlyNumber" />
                                                    <template #append>
                                                        <b-dropdown :text="selectedUnit.Label" variant="gray" size="sm">
                                                            <b-dropdown-item-button @click="selectedUnit = u;" v-for="u in slidingUnits" :key="u.Id" >
                                                                {{ u.Label }}
                                                            </b-dropdown-item-button>
                                                        </b-dropdown>
                                                    </template>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </template>    
                                </b-tab>
                                <!-- Periode Intervalle -->
                                <!-- Range -> Intervalle -->
                                <b-tab v-if="hasRangedPeriod" @click="selectPeriodType('Range') /*selectedType = 'Range'*/" :title="$t('Range')"  title-item-class="px-2" :title-link-class="{ 'text-muted bg-gray rounded-pill p-1': selectedType != 'Range' }">
                                    <!-- Annuelle selectionnée -->
                                    <template v-if="selectedPeriod == 'Year' || simplePeriodTimeUnit == 'Year'">
                                        <b-row>
                                            <!-- Debut -->
                                            <b-col>
                                                <b-row>
                                                    <b-col cols="4">
                                                        <!-- Start -> Début -->
                                                        <label :for="$id('rangeYStart')">{{$t('Start')}}</label>
                                                    </b-col>
                                                    <b-col class="pl-0">
                                                        <b-form-select :id="$id('rangeYStart')"
                                                            :options="availableYears"
                                                            value-field="Id"
                                                            text-field="Label"
                                                            size="sm"
                                                            plain
                                                            v-model="selectedYearStart"
                                                            :state="yearValid"
                                                            class="w-100"/>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            
                                            <!-- Fin -->
                                            <b-col >
                                                <b-row>
                                                    <b-col cols="4" >
                                                        <!-- End -> Fin -->
                                                        <label :for="$id('rangeYEnd')">{{$t('End')}}</label>
                                                    </b-col>
                                                    <b-col class="pl-0" >
                                                        <b-form-select :id="$id('rangeYEnd')"
                                                                :options="availableYears"
                                                                value-field="Id"
                                                                text-field="Label"
                                                                size="sm"
                                                                plain
                                                                v-model="selectedYearEnd"
                                                                :state="yearValid"
                                                                class="w-100" />
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            
                                        </b-row>
                                    </template>

                                    <!-- Mensuelle sélectionnée -->
                                    <template v-else-if="selectedPeriod == 'Month' || simplePeriodTimeUnit == 'Month'">
                                        <!-- Start -> Début -->
                                        <b-row class="mb-1">
                                            <b-col cols="2" class="pr-0">
                                                <label :for="$id('rangeMStartMonth')" >{{$t('Start')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                    <b-form-select :id="$id('rangeMStartMonth')"
                                                                :options="availableMonths"
                                                                value-field="Id"
                                                                text-field="Label"
                                                                size="sm"
                                                                plain
                                                                v-model="selectedMonthStart"
                                                                :state="monthValid"
                                                                class="mr-1" />

                                                    <template #append>
                                                        <b-form-select :options="availableYears"
                                                                    value-field="Id"
                                                                    text-field="Label"
                                                                    size="sm"
                                                                    plain
                                                                    v-model="selectedYearStart"
                                                                    :state="yearValid" />
                                                    </template>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>

                                        <!-- End -> Fin -->
                                        <b-row>
                                            <b-col cols="2" class="text-center" >
                                                <label :for="$id('rangeMEndMonth')" >{{$t('End')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                    <b-form-select :id="$id('rangeMEndMonth')"
                                                                :options="availableMonths"
                                                                value-field="Id"
                                                                text-field="Label"
                                                                size="sm"
                                                                plain
                                                                v-model="selectedMonthEnd"
                                                                :state="monthValid"
                                                                class="mr-1" />

                                                    <template #append>
                                                        <b-form-select :options="availableYears"
                                                                    value-field="Id"
                                                                    text-field="Label"
                                                                    size="sm"
                                                                    plain
                                                                    v-model="selectedYearEnd"
                                                                    :state="yearValid" />
                                                    </template>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </template>

                                    <!-- Hebdomadaire sélectionnée -->
                                    <template v-else-if="selectedPeriod == 'Week' || simplePeriodTimeUnit == 'Week'">
                                       <!-- Start -> Début -->
                                        <b-row class="mb-1" >
                                            <b-col cols="2" class="pr-0">
                                                <label :for="$id('rangeWStartWeek')">{{$t('Start')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                    <b-form-select :id="$id('rangeWStartWeek')" size="sm" plain v-model="selectedWeekStart" :state="weekValid" class="mr-1">
                                                        <b-form-select-option v-for="n in 52" :key="n" :value="n">{{$t('WeekLabel', {number : n})}}</b-form-select-option>
                                                    </b-form-select>

                                                    <template #append>
                                                        <b-form-group class="w-100 px-0 mx-0 py-0 my-0">
                                                            <b-form-select :options="availableYears"
                                                                            value-field="Id"
                                                                            text-field="Label"
                                                                            size="sm"
                                                                            plain
                                                                            v-model="selectedYearStart"
                                                                            :state="yearValid" />
                                                        </b-form-group>
                                                    </template>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>

                                         <!-- End -> Fin -->
                                        <b-row >
                                            <b-col cols="2" class="text-center">
                                                <label :for="$id('rangeWEndWeek')">{{$t('End')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                        <b-form-select :id="$id('rangeWEndWeek')" size="sm" plain v-model="selectedWeekEnd" :state="weekValid" class="mr-1">
                                                            <b-form-select-option v-for="n in 52" :key="n" :value="n">{{$t('WeekLabel', {number : n})}}</b-form-select-option>
                                                        </b-form-select>

                                                        <template #append>
                                                            <b-form-group class="w-100 p-0 m-0">
                                                                <b-form-select :options="availableYears"
                                                                                value-field="Id"
                                                                                text-field="Label"
                                                                                size="sm"
                                                                                plain
                                                                                v-model="selectedYearEnd"
                                                                                :state="yearValid" />
                                                            </b-form-group>
                                                        </template>
                                                    </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </template>

                                    <!-- Autre période sélectionnée -->
                                    <template v-else>
                                        <b-row class="mb-1" align-h="between" align-v="center">
                                            <b-col cols="2">
                                                <label :for="$id('rangeStartDate')">{{$t('Start')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="startDate"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="date"
                                                        :state="dayValid"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col class="pl-0" v-if="selectedPeriod == 'Hour' || selectedPeriod == 'Minutes10' || simplePeriodTimeUnit == 'Hour' || simplePeriodTimeUnit == 'Minutes10'">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="startHour"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="time"
                                                        :state="hourValid"
                                                        @blur="startHour = getNearestTenMinutes(startHour)"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="2" class="text-center">
                                                <label :for="$id('rangeEndDate')">{{$t('End')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="endDate"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="date"
                                                        :state="dayValid"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col class="pl-0" v-if="selectedPeriod == 'Hour' || selectedPeriod == 'Minutes10' || simplePeriodTimeUnit == 'Hour' || simplePeriodTimeUnit == 'Minutes10'">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="endHour"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="time"
                                                        :state="hourValid"
                                                        @blur="endHour = getNearestTenMinutes(endHour)"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </b-tab>
                                
                                <!-- Periode Date a Date -->
                                 <!-- DateToDate -> Date-à-date -->
                                <b-tab v-if="hasDateToDatePeriod" @click="selectPeriodType('DateToDate') /*selectedType = 'DateToDate'*/" :title="$t('DateToDate')"  title-item-class="" :title-link-class="{ 'text-muted bg-gray rounded-pill p-1': selectedType != 'DateToDate' }">
                                    <template>
                                        <b-row class="mb-1" align-h="between" align-v="center">
                                            <b-col cols="2">
                                                <!-- Start -> Début -->
                                                <label :for="$id('StartDate')">{{$t('Start')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="startDate"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="date"
                                                        :state="dayValid"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col class="pl-0" v-if="selectedPeriod == 'Hour' || selectedPeriod == 'Minutes10'">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="startHour"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="time"
                                                        :state="hourValid"
                                                        @blur="startHour = getNearestTenMinutes(startHour)"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="2" class="text-center">
                                                <!-- End -> Fin -->
                                                <label :for="$id('EndDate')">{{$t('End')}}</label>
                                            </b-col>
                                            <b-col class="pl-0">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="endDate"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="date"
                                                        :state="dayValid"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col class="pl-0" v-if="selectedPeriod == 'Hour' || selectedPeriod == 'Minutes10'">
                                                <b-input-group>
                                                    <b-form-input
                                                        v-model="endHour"
                                                        button-only
                                                        right
                                                        locale="fr"
                                                        size="sm"
                                                        type="time"
                                                        :state="hourValid"
                                                        @blur="endHour = getNearestTenMinutes(endHour)"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </b-tab>
                            </b-tabs>
                        </b-row>
                    </b-card-body>
                </b-card>
                <hr class="my-1"/>
                <b-card v-if="hasCompare && (selectedPeriod != 'Year' && selectedPeriod != 'Minutes10')" class="py-0 w-100" body-class="d-flex bg-white flex-column no-border px-0 py-1 my-0">
                    <b-card-body class="py-0">
                        <!-- Comparison -> Comparaison -->
                        <b-row align-v="center" >
                            <b-col class="px-2">
                                <label :for="$id('compare')" class="m-0">{{$t('Comparison')}}</label>
                            </b-col>
                             <!-- ComparisonTooltip -> Elle permet de comparer des périodes entre elles -->
                            <b-col cols="auto pr-0" >
                                <b-form-checkbox :id="$id('compare')" v-model="isCompare" switch v-b-tooltip.hover :title="$t('ComparisonTooltip')" />
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            
                <!-- Tendance -->
                <TrendPeriod 
                    v-if="HasTrend || (HasTrendOnSimpleMode && selectedMode === modeEnum.Simple) || (HasTrendOnAdvancedMode && selectedMode === modeEnum.Advanced)"
                    :Configs.sync="configs" 
                    :UseTrend.sync="useTrend" 
                    :Variant="Variant" 
                    :AvailableYears.sync="availableYears"
                    :HasTrendType="hasTrendType"
                    :HasPreviousTrend="hasPreviousTrend"
                    :HasLastYearTrend="hasLastYearTrend"
                    :HasRefYearTrend="hasRefYearTrend"
                    :HasLastYear="hasLastYear"
                    :HasRefPeriod="hasRefPeriod"
                    :HasReferencePeriod="hasReferencePeriod"/>
                
                <!-- Messages d'erreurs -->
                 <!-- Sélection des années incorrectes -->
                <b-form-invalid-feedback v-if="selectedType == 'Range'" :state="yearValid" class="text-center">
                    {{$t('InvalidYearRange')}}
                </b-form-invalid-feedback>
                 <!-- Sélection des mois incorrectes -->
                <b-form-invalid-feedback v-if="selectedPeriod == 'Month' && selectedType == 'Range'" :state="monthValid" class="text-center">
                    {{$t('InvalidMonthRange')}}
                </b-form-invalid-feedback>
                <!-- Sélection des semaines incorrectes -->
                <b-form-invalid-feedback v-if="selectedPeriod == 'Week' && selectedType == 'Range'" :state="weekValid" class="text-center">
                    {{$t('InvalidWeekRange')}}
                </b-form-invalid-feedback>
                <!-- Sélection des journées incorrectes -->
                <b-form-invalid-feedback v-if="selectedPeriod == 'Day' || ['DateToDate', 'Range'].includes(selectedType)" :state="dayValid" class="text-center">
                    {{$t('InvalidDayRange')}}
                </b-form-invalid-feedback>
                <!-- Sélection des heures incorrectes -->
                <b-form-invalid-feedback v-if="['DateToDate', 'Range'].includes(selectedType)" :state="hourValid" class="text-center">
                    {{ $t('InvalidHourRange')}}
                </b-form-invalid-feedback>
                <!-- La durée de la période glissante sélectionnée est plus grande que l'ensemble des données disponibles -->
                <b-form-invalid-feedback v-if="selectedMode == modeEnum.Advanced && selectedType == 'Sliding'" :state="durationValid" class="text-center" >
                    {{$t('InvalidSlidingDuration')}}
                </b-form-invalid-feedback>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script lang="ts">
    import { Component, Watch } from 'vue-property-decorator';
    import PeriodConfig from './PeriodConfig';
    import TrendPeriod from './TrendPeriod.vue';
    import ModeEnum from '@/enums/ModeEnum';
    import Dictionary from '@/types/Dictionary'; 
    import Sliding from '@/types/Config/Sliding';
    import Range from '@/types/Config/Range';
    import DateToDate from '@/types/Config/DateToDate';
    import moment from 'moment';
    /** Traductions */
    import locales from './locales/SinglePeriod.json';
    import localesPeriodConfig from './locales/PeriodConfig.json';

    /** Paramétrage du composant SinglePeriod */
	@Component({
		components: {
			PeriodConfig,
            TrendPeriod
		},
        i18n: { 
            messages: locales
            , sharedMessages: localesPeriodConfig
         }
	})
	export default class SinglePeriod extends PeriodConfig {
        /** Permet l'utilisation de l'enum dans template
        ** Enumeration pour le mode de période (Simple ou Avancé)
        **/
        private modeEnum = ModeEnum;

        /** Mode de configuration de la période */
        public selectedMode: ModeEnum = ModeEnum.Simple;

        /** Identifiant de la période */
        private periodId: string = "";

        /** Utilisation d'une tendance */
        private useTrend: boolean = false;

        /** Type de spécification de la période */
        public selectedType: string = "";

        /** Identifiant de la périodicité sélectionnée par défaut */
        public selectedPeriod: string = "";

        /** Permet la prise en compte de la comparaison des périodes lorsqu'on est en mode période avancée */
        private isCompare : boolean = false;
        
        /** Index des boutons de selection de la spécification de la période */
        public tabIndex: number = 0;

        /** Type de période sélectionnée  */
        public speriods: Sliding | DateToDate | Range = { Mode: "Simple", Type: "Sliding", Duration: 1, TimeUnit: "Year", Periodicity: "Month", Compare: false };

        /** Liste des périodes simples filtrées */
        private filteredSimplePeriods: { Id: string, Label: string, Extras: Dictionary<any> }[] = [];

        /**
         * Met à jour le mode de période
         * @param modeSelected Valeur de l'Enum de ModeEnum
         */
        private setPeriodMode(modeSelected: ModeEnum) {
            this.selectedMode = modeSelected;
            // Période Simple
            if (modeSelected === ModeEnum.Simple) {
                // Type de période simple par défaut
                this.simplePeriodType = "Month";
                this.selectedPeriod = "Month_12";
                //this.isCompare = false;

                this.hasPeriodWithPeriodicity ? this.setSimplePeriod(this.simplePeriodType) : this.setSimpleTimeUnit("Year");
            }
        }

        /**
         * Permet de mettre à jour le type de période avancée (Glissant, Intervalle ou Date-a-date)
         * @param periodType Type de la période 
         */
        private selectPeriodType(periodType: string){
            this.selectedType = periodType;

            // on vérifie que si on a startDate ou endDate vide, on remet la valuer par défaut
            this.startDate = this.startDate == "" ? this.yesterday.toISOString().split('T')[0] : this.startDate; 
            this.endDate = this.endDate == "" ? this.today.toISOString().split('T')[0] : this.endDate; 
        }

        /**
         * Met à jour le type de période simple et affiche les périodes correspondantes
         * @param value Type de périodicité
         */
         private setSimplePeriod(value: string) {
            // filtrer la liste des periodes simples si id contient le periodType
            this.simplePeriodType = value;
            this.filteredSimplePeriods = this.simplePeriods.filter(s => s.Id.includes(value));
        
            if(value == "Year")
                this.isCompare = false;

            if(this.filteredSimplePeriods && this.filteredSimplePeriods.length > 0){
                this.speriods = this.filteredSimplePeriods[0].Extras['Period'];
                this.periodId = this.filteredSimplePeriods[0].Id;
                this.selectedPeriod = this.speriods.Periodicity;
            }
        }

        /**
         * Met à jour le type de période simple et affiche les périodes correspondantes
         * @param value Type de TimeUnit
         */
        private setSimpleTimeUnit(value: string){
            this.simplePeriodTimeUnit = value;
            this.filteredSimplePeriods = this.simplePeriods.filter(s => s.Extras.Period.TimeUnit.includes(value));

            if(this.filteredSimplePeriods && this.filteredSimplePeriods.length > 0){
                this.speriods = this.filteredSimplePeriods[0].Extras['Period'];
                this.periodId = this.filteredSimplePeriods[0].Id;
                this.selectedPeriod = this.speriods.Periodicity;
            }
        }

        /**
         * Met à jour le type de période avancée
         * @param value type de période
         */
        private setAdvancedPeriod(value: string){
            this.selectedPeriod = value;

            if(value == "Year" || value == "Minutes10")
                this.isCompare = false;

            this.endHour = this.getEndHour();
            // on vérifie que si on a startDate ou endDate vide, on remet la valuer par défaut
            this.startDate = this.startDate == "" ? this.yesterday.toISOString().split('T')[0] : this.startDate; 
            this.endDate = this.endDate == "" ? this.today.toISOString().split('T')[0] : this.endDate; 
        }

        /** Liste des périodes du mode avancé */
        private advancedPeriods: { Id: string, Label: string }[] = [
            { Id: 'Year', Label: this.$t('Annual').toString() },
            { Id: 'Month', Label: this.$t('Monthly').toString() },
            { Id: 'Week', Label: this.$t('Weekly').toString() },
            { Id: 'Day', Label: this.$t('Daily').toString() },
            { Id: 'Hour', Label: this.$t('Hourly').toString() },
            { Id: 'Minutes10', Label: this.$t('TenMinutes').toString() }
        ]

        /** Liste des unites glissantes */
        private slidingUnits: { Id: string, Label: string }[] = [
            {Id: 'Year', Label: this.$t('TimeUnits.LastYears').toString()},
            {Id: 'Month', Label: this.$t('TimeUnits.LastMonths').toString()},
            {Id: 'Week', Label: this.$t('TimeUnits.LastWeeks').toString()},
            {Id: 'Day', Label: this.$t('TimeUnits.LastDays').toString()}
        ]

        /** Liste des mois */
        private availableMonths: {Id: string, Label: string}[] = this.getMonths();

        /** Année de départ pour la fonction getYears() de PeriodConfig */
        private startYear : number = 0;

        /** Liste des années disponibles */
        private availableYears: {Id: number, Label: string}[] = [];

        /** Valeur du mois de départ selectionné */
        public selectedMonthStart: string = this.availableMonths.at(0).Id;

        /** Valeur du mois de fin selectionné */
        public selectedMonthEnd: string = this.availableMonths.at(0).Id;

        /** Valeur de l'année de départ selectionné */
        public selectedYearStart: number = 0;

        /** Valeur de l'année de fin selectionné */
        public selectedYearEnd: number = 0;

        /** Valeur de l'unité glissante sélectionnée */
        public selectedUnit: { Id: string, Label: string } = this.slidingUnits[0];

        /** Valeur de la semaine de départ sélectionnée */
        public selectedWeekStart: number = 1;
        /** Valeur de la semaine de fin sélectionnée */
        public selectedWeekEnd: number = 1;

        /** Durée de période pour mode avancé  */
        public duration: number = 1;

        public today : Date = new Date();

        public yesterday = new Date(Date.now() - 86400000);

        /** Date de fin pour le b-form-datepicker */
        public endDate: string = this.today.toISOString().split('T')[0];

        /** Date de départ pour le b-form-datepicker */
        public startDate: string = this.yesterday.toISOString().split('T')[0]; // that is: 24 * 60 * 60 * 1000

        /** Heure de départ pour le b-form-timepicker */
        public startHour: string = "00:00"

        /** Heure de fin pour le b-form-timepicker */
        public endHour: string = this.getEndHour();

        /** Permet de donner la valeur de l'heure de fin en fonction de la périodicité sélectionnée */
        private getEndHour() : string {

            console.debug("SinglePeriod - getEndHour - selectedPeriod : %O", this.selectedPeriod);

            let hour: string = "00:00";            

            if (this.selectedPeriod == 'Hour')
                hour = "23:00";

            if (this.selectedPeriod == 'Minutes10')
                hour = "23:50";

            console.debug("SinglePeriod - getEndHour - hour : %O", hour);

            return hour;
        }

        /**
         * Calcule l'heure à la dizaine de minutes la plus proche
         * @param hour Heure à recalculer
         */
        private getNearestTenMinutes(hour : string) {
            if(!hour) return "00:00";

            console.debug("SinglePeriod - getNearestTenMinutes - hour : %O", hour);

            let splitTime = hour.split(':');
            let currentHour = Number(splitTime[0]);
            let minutes = Number(splitTime[1]);
            let time: string = "";

            if (this.selectedPeriod == 'Minutes10'){
                // Donne la dizaine la plus proche
                let nearestTen = Math.round(minutes / 10) * 10;

                // dizaine plus proche de l'heure suivante
                if (nearestTen == 60) {
                    // Passage à l'heure suivante (si 23 -> 0)
                    let nextHour = (currentHour + 1) % 24;
                    
                    // Formatage de l'heure
                    let formattedHour = nextHour < 10 ? "0" + nextHour : nextHour.toString();
                    
                    time = formattedHour + ":00";
                } else {
                    // On garde l'heure actuelle
                    let formattedMin = nearestTen === 0 ? "00" : nearestTen.toString();
                    time = splitTime[0] + ":" + formattedMin;
                }
            }
            else 
                time = splitTime[0] + ":00";
            
            console.debug("SinglePeriod - getNearestTenMinutes - time : %O", time);
            
            return time;
        }

        /** Validité de l'année
         * @description (est à null par défaut pour pas afficher l'invalidité)
         */
         private yearValid: boolean = null;
        
         /** Validité du mois
         * @description (est à null par défaut pour pas afficher l'invalidité)
         */ 
         private monthValid: boolean = null;
        
         /** Validité de la semaine
         * @description (est à null par défaut pour pas afficher l'invalidité)
         */
        private weekValid: boolean = null;
        
        /** Validité de la journée
         * @description (est à null par défaut pour pas afficher l'invalidité)
         */
        private dayValid: boolean = null;

        /** Validité des heures
         * @description (est à null par défaut pour pas afficher l'invalidité)
         */
        private hourValid: boolean = null;

        /**
         * Validité de la saisie de la durée de la période glissante
         * @description (est à null par défaut pour pas afficher l'invalidité)
         */
        private durationValid: boolean = null;

        private loadPeriod(parameters){
            console.debug("SinglePeriod - loadPeriod() - parameters :", parameters);

            if (parameters && "Periods" in parameters && parameters["Periods"]) {
                // Simple ou Avancé
                this.selectedMode = (ModeEnum[parameters["Periods"][0].Mode] as unknown as ModeEnum);
                // Glissant ou Intervalle ou Date à Date (mode avancé)
                let configType: string = parameters['Periods'][0].Type;
                let splitType: string[] = configType.split('.');
                configType = splitType[splitType.length - 1];
                this.selectedType = configType;

                console.debug("SinglePeriod - loadPeriod() - selectedType : %O", this.selectedType);

                // Periodicité pour le mode simple
                this.simplePeriodType = parameters["Periods"][0].Periodicity;

                // Détermination de la périodicité du mode simple en cas d'indication de tendance
                if(this.hasTrendType)
                    this.simplePeriodTimeUnit = parameters["Periods"][0].TimeUnit;
                
                this.hasPeriodWithPeriodicity ? this.setSimplePeriod(this.simplePeriodType) : this.setSimpleTimeUnit(this.simplePeriodTimeUnit);
                    
                console.debug("SinglePeriod - loadPeriod() - simplePeriodType - ", this.simplePeriodType);

                // Information de durée + unité temps en mode avancé type glissant
                this.duration = parameters["Periods"][0].Duration ? parameters["Periods"][0].Duration : 3;
                this.selectedUnit = parameters["Periods"][0].TimeUnit ? this.slidingUnits.find(x => x.Id == parameters["Periods"][0].TimeUnit)  : this.slidingUnits[0];

                this.selectedYearStart = parameters["Periods"][0].Start ? (parameters["Periods"][0].Start.split("|").length > 1 ? parameters["Periods"][0].Start.split("|")[1] : parameters["Periods"][0].Start) : new Date().getFullYear();
                this.selectedYearEnd = parameters["Periods"][0].End ? (parameters["Periods"][0].End.split("|").length > 1 ? parameters["Periods"][0].End.split("|")[1] : parameters["Periods"][0].End) : new Date().getFullYear();

                this.selectedMonthStart = parameters["Periods"][0].Start ? (parameters["Periods"][0].Start.split("|").length > 1 && parameters["Periods"][0].Periodicity == 'Month' ? parameters["Periods"][0].Start.split("|")[0] : "01") : "01";
                this.selectedMonthEnd = parameters["Periods"][0].End ? (parameters["Periods"][0].End.split("|").length > 1 && parameters["Periods"][0].Periodicity == 'Month' ? parameters["Periods"][0].End.split("|")[0] : "01") : "01";

                let startWeek: string = parameters["Periods"][0].Start ? parameters["Periods"][0].Start.split("|")[0] : "1";
                this.selectedWeekStart = parameters["Periods"][0].Start && parameters["Periods"][0].Periodicity == 'Week' ? (startWeek.startsWith('0') ? parseInt(startWeek.charAt(1)) : parseInt(startWeek)) : 1;

                let endWeek: string = parameters["Periods"][0].End ? parameters["Periods"][0].End.split("|")[0] : "1";
                this.selectedWeekEnd = parameters["Periods"][0].End && parameters["Periods"][0].Periodicity == 'Week' ? (endWeek.startsWith('0') ? parseInt(endWeek.charAt(1)) : parseInt(endWeek)) : 1;

                // index tab pour la periode avancée
                switch (this.selectedType) {
                    case "Sliding":
                        this.tabIndex = 0;
                        break;
                    case "Range":
                        this.tabIndex = 1;
                        this.startDate = parameters["Periods"][0].Start.split(' ')[0]; 
                        this.startHour = parameters["Periods"][0].Start.split(' ')[1]; 
                        this.endDate = parameters["Periods"][0].End.split(' ')[0]; 
                        this.endHour = parameters["Periods"][0].End.split(' ')[1];
                        break;
                    case "DateToDate":
                        this.tabIndex = 2;
                        this.startDate = parameters["Periods"][0].StartDate.split('T')[0]; 
                        this.startHour = parameters["Periods"][0].StartDate.split('T')[1].slice(0, 5); // On slice pour n'avoir que heure et minutes 
                        this.endDate = parameters["Periods"][0].EndDate.split('T')[0];
                        this.endHour = parameters["Periods"][0].EndDate.split('T')[1].slice(0, 5); // On slice pour n'avoir que heure et minutes 
                        break;
                }

                // Si le work à la fonction de comparaison
                if(this.hasCompare)
                    this.isCompare = parameters["Periods"][0].Compare;
                this.speriods = parameters["Periods"][0];
                this.useTrend = parameters["Periods"].some(period => 'TrendType' in period);
                this.selectedPeriod = parameters["Periods"][0].Periodicity;
                this.periodId = this.simplePeriods.find(p => p.Extras["Period"].Duration == this.duration && p.Extras["Period"].TimeUnit == this.selectedUnit.Id).Id;
            }
        }

        /** Mise à jour de la période sur changement entre mode Simple et Avancé OU période sélectionnée OU type de période (Sliding, Range, DateToDate) */
        @Watch('startDate')
        @Watch('endDate')
        @Watch('startHour')
        @Watch('endHour')
        @Watch('selectedYearStart')
        @Watch('selectedYearEnd')
        @Watch('selectedMonthStart')
        @Watch('selectedMonthEnd')
        @Watch('selectedWeekStart')
        @Watch('selectedWeekEnd')
        @Watch('selectedPeriod')
        @Watch('selectedType')
        @Watch('selectedMode')
        @Watch('speriods')
        @Watch('selectedUnit')
        @Watch('simplePeriodTimeUnit')
        @Watch('duration')
        @Watch('isCompare')
        protected updatePeriods() {
            //Init du dictionnaire de configs
            this.configs.Periods.shift();

            console.debug("SinglePeriod - UpdatePeriods - type : %O - period : %O - mode : %O ", this.selectedType, this.selectedPeriod, this.selectedMode);

            if (this.selectedMode === ModeEnum.Advanced) {

                switch (this.selectedType) {
                    case 'Sliding':
                        let slidingPeriod: Sliding;
                        slidingPeriod = { Mode: 'Advanced', Periodicity: this.selectedPeriod, Type: this.selectedType, Duration: this.duration, TimeUnit: this.selectedUnit.Id, Compare: this.isCompare };
                        this.configs.Periods.unshift(slidingPeriod);

                        break;
                    case 'Range':
                        let rangePeriod: Range;
                        let sStart: string;
                        let sEnd: string;

                        if (this.selectedPeriod == 'Year' || this.simplePeriodTimeUnit == 'Year') {
                            sStart = this.selectedYearStart.toString();
                            sEnd = this.selectedYearEnd.toString();
                        }
                        else if (this.selectedPeriod == 'Month' || this.simplePeriodTimeUnit == 'Month') {
                            sStart = this.selectedMonthStart.toString() + '|' + this.selectedYearStart.toString();
                            sEnd = this.selectedMonthEnd.toString() + '|' + this.selectedYearEnd.toString();
                        }
                        else if (this.selectedPeriod == 'Week' || this.simplePeriodTimeUnit == 'Week') {
                            sStart = this.selectedWeekStart < 10 ? "0" + this.selectedWeekStart.toString() : this.selectedWeekStart.toString();
                            sEnd = this.selectedWeekEnd < 10 ? "0" + this.selectedWeekEnd.toString() : this.selectedWeekEnd.toString();

                            sStart = sStart + '|' + this.selectedYearStart.toString();
                            sEnd = sEnd + '|' + this.selectedYearEnd.toString();
                        }
                        else{
                            console.debug("SinglePeriod - UpdatePeriods - Range - startDate : %O - endDate : %O", this.startDate, this.endDate);

                            sStart = this.startDate;
                            sEnd =  this.endDate;

                            if(this.selectedPeriod != 'Day'){
                                sStart += " " + this.startHour;
                                sEnd += " " + this.endHour;
                            }
                        }

                        rangePeriod = { Mode: 'Advanced', Periodicity: this.selectedPeriod, Type: this.selectedType, Compare: this.isCompare, Start: sStart, End: sEnd };
                        this.configs.Periods.unshift(rangePeriod);

                        break;
                    case 'DateToDate':

                        console.debug("SinglePeriod - UpdatePeriods - DateToDate - startDate : %O - endDate : %O", this.startDate, this.endDate);

                        let dateToDatePeriod: DateToDate;

                        let start : Date = moment(this.startDate + ' 00:00:00Z').toDate();
                        let end : Date = moment(this.endDate + ' 00:00:00Z').toDate();

                        console.debug("SinglePeriod - UpdatePeriods - Date-a-Date - start : %O - end : %O", start, end);

                        if(this.selectedPeriod == "Hour" || this.selectedPeriod == "Minutes10"){
                            start = moment(this.startDate + ' ' + this.startHour + "Z").toDate();
                            end = moment(this.endDate + ' ' + this.endHour + "Z").toDate();
                        }

                        dateToDatePeriod = { Mode: 'Advanced', Periodicity: this.selectedPeriod, Type: this.selectedType, Compare: this.isCompare, StartDate: start, EndDate: end };
                        this.configs.Periods.unshift(dateToDatePeriod);
                        break;
                }
            }
            else {
                console.debug("SinglePeriod - updatePeriods - speriods : %O | this.isCompare : %O", this.speriods, this.isCompare);

                let periodicity = this.selectedPeriod;
                this.speriods.Compare = this.isCompare;

                // Si comparaison activé
                if (this.isCompare) {
                    let sliding : Sliding;

                    sliding = { Mode: 'Simple', Periodicity: periodicity, Type: this.selectedType, Duration: (this.speriods as Sliding).Duration, TimeUnit: (this.speriods as Sliding).TimeUnit, Compare: this.isCompare };
                    this.configs.Periods.unshift(sliding);
                }
                else
                    this.configs.Periods.unshift(this.speriods);
            }

            console.debug("SinglePeriod - updatePeriods - this.configs :", this.configs);
        }

        /** Génération du titre pour la partie période */
        private GeneratePeriodTitle(){
            let title = "";
            let period = this.configs["Periods"];

            if (this.selectedMode === ModeEnum.Simple) {
                let simplePLabel = this.simplePeriods.find(x => x.Extras["Period"].Duration == period[0].Duration && x.Extras["Period"].TimeUnit == period[0].TimeUnit).Label;

                if(simplePLabel)
                    title += simplePLabel;
            }
            else{
                console.debug("SinglePeriod - GeneratePeriodTitle period.Periodicity", period[0].Periodicity);

                // Type de période avancée lowerCase (annuelle, mensuelle, hebdomadaire, ...)
                let advancedPLabel = this.advancedPeriods.find(x => x.Id == period[0].Periodicity).Label.toLowerCase();

                switch (this.selectedType) {
                    case 'Sliding':
                        // Durée
                        title += period[0].Duration + " ";

                        // Unité de temps
                        let periodUnit = this.slidingUnits.find(x => x.Id == period[0].TimeUnit).Label.toLowerCase();
                        periodUnit = period[0].Duration > 1 ? periodUnit.replaceAll('(s)', 's') : periodUnit.replaceAll('(s)', '');
                        
                        title += periodUnit + " ";

                        //Type de période
                        if(periodUnit.includes('mois') || periodUnit.includes('jour')){
                            if(advancedPLabel.endsWith('elle'))
                                advancedPLabel = advancedPLabel.slice(0,-2)

                            if(advancedPLabel.endsWith('ière'))
                                advancedPLabel = advancedPLabel.replace('ière', 'ier');  
                        }

                        title += "en " + advancedPLabel;

                    break;
                    case 'Range':
                        title += "Intervalle ";
                        
                        console.debug("SinglePeriod - GeneratePeriodTitle period.start", period[0].Start);

                        let start: string = period[0].Start;
                        let end: string = period[0].End;

                        // Type de période
                        if(advancedPLabel.endsWith('elle'))
                            advancedPLabel = advancedPLabel.slice(0,-2);

                        if(advancedPLabel.endsWith('ière'))
                            advancedPLabel = advancedPLabel.replace('ière', 'ier'); 

                        title += advancedPLabel + " ";

                        // Dates
                        if(start.includes('|')){
                            if(period[0].Periodicity == 'Week')
                                title += "entre Sem." + start.replace('|',' ') + " et Sem." + end.replace('|',' ');
                            else
                                title += "du " + start.replace('|','/') + " au " + end.replace('|','/');
                        }
                        else if(period[0].Periodicity == 'Day'){
                            console.debug("SinglePeriod - GeneratePeriodTitle split", start.split(' '));
                            title += start.split(' ')[0] + " au " + end.split(' ')[0];
                        }
                        else
                            title += start + " au " + end;
                        
                    break;
                    case 'DateToDate':
                        title += "Date-à-Date ";

                        title += advancedPLabel + " du ";

                        title += moment(period[0].StartDate).format('DD/MM/YYYY') + " au ";
                        title += moment(period[0].EndDate).format('DD/MM/YYYY');

                    break;
                }
            }

            return title;
        }

        /** Méthode pour vérifier si la période renseigné est invalide */
        public CheckPeriodInvalidity() : boolean {
            console.debug("SinglePeriod - CheckPeriodInvalidity - Periods : %O - this.selectedMode : %O", this.configs["Periods"], this.selectedMode);

            let dateInvalid: boolean = false;

            /** Reset des différents états des sélections de périodes  */
            this.yearValid = null;
            this.monthValid = null;
            this.weekValid = null;
            this.dayValid = null;
            this.hourValid = null;
            this.durationValid = null;

            // Récupération de la première période
            let firstPeriod = this.configs["Periods"][0];

            let daysType = ["Day","Hour","Minutes10"];

            // Verification des dates sur la période avancé uniquement
            if (this.configs && 'Periods' in this.configs && this.selectedMode == ModeEnum.Advanced) {
                switch(this.selectedType) {
                    case "Sliding":
                        let selectedDuration : number = firstPeriod.Duration;
                        let diffYear : number = (this.today.getFullYear() - this.startYear) + 1;
                        let result : number = 0;    

                        console.debug("SinglePeriod - CheckPeriodInvalidity - Sliding - selectedDuration : %O - diffyear : %O", selectedDuration, diffYear);

                        // Permet de calculer la différence entre la durée sélectionnée et le nombre d'année de présence de données
                        switch (firstPeriod.TimeUnit) {
                            case "Year":
                                result = selectedDuration - diffYear;
                                break;
                            case "Month":
                                result = (selectedDuration / 12) - diffYear;
                            break;
                            case "Week":
                                result = (selectedDuration / 52) - diffYear;
                            break;
                            case "Day":
                                result = (selectedDuration / 366) - diffYear;
                            break;    
                        }

                        dateInvalid = result > 0;
                        break;
                    case "Range":
                        // Annuel -> vérification année départ antérieur année fin
                        if (firstPeriod.Periodicity == 'Year')
                            dateInvalid = (firstPeriod.Start > firstPeriod.End);
                        // périodicité inf. Journalier -> vérification dates saisies valides et antériorité                         
                        else if(daysType.includes(firstPeriod.Periodicity)){
                            // La date de début ou de fin est invalide (ex: "31/04/2026")
                            if (isNaN(new Date(firstPeriod.Start).getTime()) || isNaN(new Date(firstPeriod.End).getTime())){
                                dateInvalid = true;    
                                break;
                            }

                            dateInvalid = moment(firstPeriod.Start).isAfter(firstPeriod.End);
                        }
                        // autres périodicité
                        else {
                            let yearStart: string = firstPeriod.Start.split("|")[1];
                            let yearEnd: string = firstPeriod.End.split("|")[1];

                            let monthOrWeekStart: string = firstPeriod.Start.split("|")[0];
                            let monthOrWeekEnd: string = firstPeriod.End.split("|")[0];

                            dateInvalid = (Number(yearStart + monthOrWeekStart) > Number(yearEnd + monthOrWeekEnd));
                        }
                        console.debug("SinglePeriod - CheckPeriodInvalidity - dateInvalid", dateInvalid);
                        break;
                    case "DateToDate":
                        // ⚠️ Ces 2 conditions servent en cas d'une réactualisation SANS modification de la période ⚠️
                        if (typeof firstPeriod.StartDate === 'string') {
                            firstPeriod.StartDate = new Date(firstPeriod.StartDate);
                        }
                        if (typeof firstPeriod.EndDate === 'string') {
                            firstPeriod.EndDate = new Date(firstPeriod.EndDate);
                        }

                        // La date de début ou de fin est invalide (ex: "31/04/2026")
                        if (isNaN(firstPeriod.StartDate.getTime()) || isNaN(firstPeriod.EndDate.getTime())) {
                            dateInvalid = true;    
                            break;
                        }

                        dateInvalid = moment(firstPeriod.StartDate).isAfter(firstPeriod.EndDate);
                        console.debug("SinglePeriod - CheckPeriodInvalidity - dateInvalid - DateToDate", dateInvalid);
                        break;
                }
            }

            if (dateInvalid) {                
                // Si Date a Date OU la périodicité est inférieure à la journée
                if (this.selectedType == "DateToDate") {
                    let start: Date = firstPeriod.StartDate;                  
                    let end: Date = firstPeriod.EndDate;                  

                    // Une des deux dates est invalide
                    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                        this.dayValid = false;
                        this.errorList.push({ Message: this.$t('InvalidDates').toString() });
                    }
                    else {
                        // Pour comparer les dates, il faut partir du format ISO pour passer outre la partie fuseau horaire pouvant fausser le résultat
                        let startISO: string = start.toISOString().split('T')[0];
                        let endISO: string = end.toISOString().split('T')[0];

                        if(startISO > endISO)
                        {
                            this.dayValid = false;
                            this.errorList.push({ Message: this.$t('InvalidDates').toString() }); // Les dates sélectionnées sont incorrectes
                        }

                        if(startISO == endISO && start.getTime() > end.getTime())
                        {
                            this.hourValid = false;
                            this.errorList.push({ Message: this.$t('InvalidHours').toString() });
                        }
                    }
                }
                // Si Glissant
                else if(this.selectedType == "Sliding"){
                    this.durationValid = false;
                    this.errorList.push({ Message: this.$t('InvalidSlidingDuration').toString() }); // La durée de la période glissante sélectionnée est plus grande que l'ensemble des données disponibles
                }
                // Si Intervalle
                else{
                    if (firstPeriod.Periodicity == "Year") {
                        this.yearValid = false;
                        this.errorList.push({ Message: this.$t('InvalidYears').toString() }); // Les années sélectionnées sont incorrectes
                    }

                    if (firstPeriod.Periodicity == "Month") {
                        this.monthValid = false;

                        if (this.selectedYearStart > this.selectedYearEnd) {
                            this.yearValid = false;
                            this.errorList.push({ Message: this.$t('InvalidMonthlyPeriod').toString() }); // La période mensuelle sélectionnée est incorrecte
                        }
                        else
                            this.errorList.push({ Message: this.$t('InvalidMonths').toString() }); // Les mois sélectionnés sont incorrect
                    }

                    if (firstPeriod.Periodicity == "Week") {
                        this.weekValid = false;

                        if (this.selectedYearStart > this.selectedYearEnd) {
                            this.yearValid = false;
                            this.errorList.push({ Message: this.$t('InvalidWeeklyPeriod').toString() }); //  La période hebdomadaire sélectionnée est incorrecte
                        }
                        else
                            this.errorList.push({ Message: this.$t('InvalidWeeks').toString() }); // Les semaines sélectionnées sont incorrectes
                    }

                    // Période inférieure ou égale à la journée
                    if (daysType.some( el => firstPeriod.Periodicity.includes(el))){
                        let startSplit : string[] = firstPeriod.Start.split(' ');
                        let endSplit: string[] = firstPeriod.End.split(' ');

                        // Regex format Date et Heure
                        const regexDate = /^\d{4}-\d{2}-\d{2}$/;
                        
                        // Date non valides
                        if(!regexDate.test(startSplit[0]) || !regexDate.test(endSplit[0])){
                            console.debug("SinglePeriod - CheckPeriodInvalidity - Range - Saisie invalide");
                            this.dayValid = false;
                            this.errorList.push({ Message: this.$t('InvalidDates').toString() });
                        }
                        // Date de début posterieure à celle de fin
                        else if(startSplit[0] > endSplit[0]){
                            console.debug("SinglePeriod - CheckPeriodInvalidity - Range - Saisie D > Saisie F");
                            this.dayValid = false;
                            this.errorList.push({ Message: this.$t('InvalidDates').toString() });
                        }                            
                        
                        // En cas de même date, verification heure début posterieure à celle de fin
                        if(startSplit[0] == endSplit[0] && startSplit[1] > endSplit[1]){
                            this.hourValid = false;
                            this.errorList.push({ Message: this.$t('InvalidHours').toString() });
                        }
                    }
                } 
            }

            return dateInvalid;
        }

        /** Initialisation du composant après sélection d'une fonction Analysis */
        @Watch('configs.Feature', { immediate: true })
        private init(newVal, oldVal){
            if ("Feature" in this.configs && this.configs["Feature"] && newVal != oldVal) {
                /** Initialisation de la machine d'état de périodes */
                this.initStateMachine(newVal, oldVal).then(() => {
                    this.filteredSimplePeriods = this.simplePeriods.filter(s => s.Id.includes(this.simplePeriodType));
                    this.loadPeriod(this.configs);
                }) ;
            }
        }

        /** 
         * Pointeur vers fonction pour désactiver watchers
         * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
         **/
        private unwatchGetPerimeterItems = undefined;

        created() {
            console.debug("SinglePeriod - created - configs['Periods'] : %O", this.configs['Periods']);

            this.unwatchGetPerimeterItems = this.$store.watch((state, getters) => getters['GetPerimeterItems']('StartDate'), date => {
                console.debug("SinglePeriod - created - date : %O, date.length > 0 && this.startYear == 0 : %O", date, date.length > 0 && this.startYear == 0);

                if(date.length > 0 && this.startYear == 0){
                    this.startYear = Number(date.at(0).split("-")[0]);
                    this.availableYears = this.getYears(this.startYear);
                }
            }, { immediate: true });
        }

        beforeDestroy() {
            // Libère les watchers
            if (this.unwatchGetPerimeterItems)
                this.unwatchGetPerimeterItems();
        }
    }
</script>

<style scoped>
</style>